import React, { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import themeCreator from "@Themes/themeCreator";
import { InputAdornment } from "@mui/material";
import useSendPutRequest from "@Hooks/useSendPutRequest";
import GenericPopup from "../../Components/Popup/Popup";
import { useNavigate } from "react-router-dom";
import Searchable_DropDown from "@Components/DropDown/SearchableDropDown";
import DropDown from "../../Components/DropDown/DropDown";
import { Grid, Typography, TextField, Button, Box, Chip } from "@mui/material";
import { red } from "@mui/material/colors";
import CancelIcon from "@mui/icons-material/Cancel";
import { inputTypes } from "../../Utils/HelpingObjects/HelpingObjects";
import { normalizeAttrsToString } from "../../Utils/Validations/HelperFunctions/FormaterFunctions";
import LockIcon from "@mui/icons-material/Lock";
import DateSelector from "@Components/DateTimePickers/DatePicker";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { formatDateUTC } from "../../Utils/Validations/HelperFunctions/FormaterFunctions";
import _ from "lodash";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";
import MultiSelectionDropDown from "../../Components/DropDown/MultiSelectionDropDown";
import UploadFileButton from "../../Components/Buttons/uploadFileButton";

export const EditSectionPopup = (
  sectionName,
  showPopup,
  closePopup,
  confirm,
  loading,
  formFields,
  initialSectionState,
  uploadDocuments = false,
  isPopupLoading = false
) => {
  const theme = themeCreator();
  const { isLoading: PutItemLoading, requestMethod: putItem } =
    useSendPutRequest();
  const [isButtonDisable, setIsButtonDisable] = useState(true);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [newSectionData, setNewSectionData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    if (initialSectionState != null && newSectionData != {}) {
      setIsButtonDisable(areObjectsEqual(newSectionData, initialSectionState));
    }
  }, [newSectionData]);

  useEffect(() => {
      setNewSectionData(initialSectionState);
  }, [initialSectionState]);

  useEffect(() => {
    if (initialSectionState != null && Object.keys(newSectionData).length > 0) {
      const isSame = areObjectsEqual(newSectionData, initialSectionState);
      const hasErrors = Object.keys(validationErrors).length > 0;
      setIsButtonDisable(isSame || hasErrors);
    }
  }, [newSectionData, validationErrors]);

  const handleFileChange = (event) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile) {
      return;
    }
    setFile(uploadedFile);
    setFileName(uploadedFile.name);
    setIsButtonDisable(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value == "" ? "" : value;
    setNewSectionData((prev) => ({ ...prev, [name]: updatedValue }));
  };
  const areObjectsEqual = (obj1, obj2) => {
    return _.isEqual(
      normalizeAttrsToString(obj1),
      normalizeAttrsToString(obj2)
    );
  };

  const handleDatePick = (fieldKey, newDate) => {
    setNewSectionData((prev) => ({
      ...prev,
      [fieldKey]: formatDateUTC(newDate),
    }));
  };

  const onCancel = () => {
    setNewSectionData(initialSectionState);
    setValidationErrors({});
    setFile(null);
    setFileName("");
    setIsButtonDisable(true);
    closePopup();
  };
  const submit = async () => {
    confirm(newSectionData, file);
    setFile(null);
    setFileName("");
    setIsButtonDisable(true);
    // setNewSectionData(initialSectionState);
    setValidationErrors({});
  };

  const checkMaturityDate = () => {
    if (
      !newSectionData.maturityPeriod ||
      newSectionData.maturityPeriod === ""
    ) {
      setNewSectionData((prev) => ({
        ...prev,
        maturityDate: null,
      }));
      return;
    }

    let baseDate = null;

    const parseDate = (dateValue) => {
      if (!dateValue) return null;

      if (dateValue instanceof Date) {
        return dateValue;
      }

      if (typeof dateValue === "number") {
        return new Date(dateValue); // timestamp
      }

      if (typeof dateValue === "string") {
        if (dateValue.includes("/")) {
          const [month, day, year] = dateValue.split("/");
          return new Date(year, month - 1, day);
        }
        return new Date(dateValue); // ISO or yyyy-MM-dd
      }

      return null;
    };

    if (newSectionData.maturityType === "INVOICE") {
      baseDate = parseDate(newSectionData.invoiceDate);
    } else if (newSectionData.maturityType === "BILL_OF_LADING") {
      baseDate = parseDate(newSectionData.bolDate);
    }

    if (baseDate && !isNaN(baseDate)) {
      baseDate.setDate(
        baseDate.getDate() + Number(newSectionData.maturityPeriod)
      );

      // Format to yyyy-MM-dd (Spring Boot-friendly)
      const yyyy = baseDate.getFullYear();
      const mm = String(baseDate.getMonth() + 1).padStart(2, "0");
      const dd = String(baseDate.getDate()).padStart(2, "0");
      setNewSectionData((prev) => ({
        ...prev,
        maturityDate: `${yyyy}-${mm}-${dd}`,
      }));
    }
  };

  useEffect(() => {
    checkMaturityDate();
  }, [
    newSectionData.maturityPeriod,
    newSectionData.invoiceDate,
    newSectionData.bolDate,
    newSectionData.maturityType,
  ]);

  let newform = (
    <Grid
      className="inputContainer"
      container
      spacing={2}
      justifyContent="flex-end"
    >
      {isPopupLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="200px"
        >
          <LoadingComponent />
        </Box>
      ) : (
        formFields?.map((field) => (
          <Grid
            item
            xs={field.size}
            key={field.key}
            sx={field.type === inputTypes.BOOLEAN ? { mr: "auto" } : undefined}
          >
            {field.type !== inputTypes.DATE &&
              field.type !== inputTypes.BOOLEAN && (
                <Typography variant="body1" sx={{ mb: 1 }} align="left">
                  {field.label}
                </Typography>
              )}
            {field.type === inputTypes.BOOLEAN && (
              <Box>
                <Typography variant="body1" sx={{ mb: 1 }} align="left">
                  {field.label}
                </Typography>
                <Box
                  sx={{
                    minHeight: 56,
                    px: 1.5,
                    display: "flex",
                    alignItems: "center",
                    border: 1,
                    borderColor: "divider",
                    borderRadius: 1,
                  }}
                >
                  <FormControlLabel
                    sx={{ m: 0 }}
                    control={
                      <Checkbox
                        checked={!!newSectionData[field.key]}
                        onChange={(e) => {
                          setNewSectionData((prev) => ({
                            ...prev,
                            [field.key]: e.target.checked,
                          }));
                        }}
                        disabled={!field.editable}
                      />
                    }
                    label={
                      newSectionData[field.key] ? "Submitted" : "Not submitted"
                    }
                  />
                </Box>
              </Box>
            )}
            {field.type === inputTypes.SEARCHABLE_DROPDOWN && !field.isList && (
              <Searchable_DropDown
                state={String(newSectionData[field.key] ?? "")}
                setState={(value) => {
                  value = value == "" ? "" : value;
                  setNewSectionData((prev) => ({
                    ...prev,
                    [field.key]: value,
                  }));
                }}
                name={field.key}
                placeholder={`Select ${field.label}`}
                items={field.options}
                disabled={!field.editable}
              />
            )}
            {field.type === inputTypes.SEARCHABLE_DROPDOWN && field.isList && (
              <Box>
                <MultiSelectionDropDown
                  state={""}
                  setState={(value) => {
                    const selectedItem = field.options.find(
                      (item) => item.id === value
                    );
                    if (value && selectedItem) {
                      field.onselect?.(value, selectedItem);
                    }
                    setIsButtonDisable(false);
                  }}
                  name={field.key}
                  placeholder={`Select ${field.label}`}
                  items={field.options}
                  disabled={!field.editable}
                />
                {field.activateNote && (
                  <Box
                    sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: theme.palette.warning.main,
                        fontWeight: 500,
                      }}
                    >
                      {field.note}
                    </Typography>
                  </Box>
                )}

                <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {[...field?.selectedObjects].map((item) => (
                    <Chip
                      key={item.id}
                      label={item.name}
                      size="small"
                      onClick={() => {
                        field.onDelete?.(item.id);
                        setIsButtonDisable(false);
                      }}
                      icon={<CancelIcon />}
                      sx={{
                        fontWeight: 520,
                        mr: 1,
                        "& .MuiChip-icon": {
                          color: red[600],
                        },
                        cursor: "pointer",
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}

            {(field.type === inputTypes.TEXT ||
              field.type === inputTypes.INTEGER_NUMBER ||
              field.type === inputTypes.FLOAT_NUMBER) && (
              <TextField
                variant="outlined"
                fullWidth
                name={field.key}
                type={
                  field.type === inputTypes.FLOAT_NUMBER ||
                  field.type === inputTypes.INTEGER_NUMBER
                    ? "number"
                    : "text"
                }
                placeholder={field.label}
                value={newSectionData[field.key] ?? ""}
                onChange={(e) => {
                  const value = e.target.value;

                  // Handle integer validation
                  if (
                    field.type === inputTypes.INTEGER_NUMBER &&
                    value?.includes(".")
                  ) {
                    setValidationErrors((prev) => ({
                      ...prev,
                      [field.key]: "Only whole numbers are allowed.",
                    }));
                  } else {
                    setValidationErrors((prev) => {
                      const newErrors = { ...prev };
                      delete newErrors[field.key]; // Remove error if fixed
                      return newErrors;
                    });
                    handleChange(e); // Update state
                  }
                }}
                onKeyDown={(e) => {
                  if (
                    field.type === inputTypes.INTEGER_NUMBER &&
                    e.key === "."
                  ) {
                    e.preventDefault(); // Block decimal input
                  }
                }}
                disabled={!field.editable}
                inputProps={
                  field.type === inputTypes.FLOAT_NUMBER
                    ? { step: "any" }
                    : field.type === inputTypes.INTEGER_NUMBER
                    ? { step: "1" }
                    : {}
                }
                InputProps={{
                  endAdornment: !field.editable && (
                    <InputAdornment position="end">
                      <LockIcon size="1.5em" thickness={5} color="gray" />
                    </InputAdornment>
                  ),
                }}
                error={!!validationErrors[field.key]}
                helperText={validationErrors[field.key]}
              />
            )}

            {field.type === inputTypes.DATE && (
              <DateSelector
                name={field.label}
                value={newSectionData[field.key]}
                error={validationErrors[field.key]}
                onPick={(newDate) => handleDatePick(field.key, newDate)}
                disabled={!field.editable}
                views={field.views}
                format={field.format}
              />
            )}
          </Grid>
        ))
      )}
      {!isPopupLoading &&
        ((uploadDocuments && sectionName !== "Document") ||
          sectionName === "Document") && (
          <Grid item xs={12}>
            <UploadFileButton
              handleFileChange={handleFileChange}
              fileName={fileName}
              acceptedTypes={["application/pdf"]}
              errorMessage="Only PDF files are allowed."
              buttonLabel={file ? "Change File" : `Upload ${sectionName}`}
              buttonVariant="outlined"
              buttonStartIcon={file ? <AttachFileIcon /> : <CloudUploadIcon />}
              fullWidth={false}
              dragAndDrop={true}
              sx={{
                backgroundColor: file
                  ? "rgba(25, 118, 210, 0.08)"
                  : "transparent",
              }}
            />

            {fileName && (
              <Box sx={{ mt: 1, display: "flex", alignItems: "center" }}>
                <AttachFileIcon
                  fontSize="small"
                  color="primary"
                  sx={{ mr: 0.5 }}
                />
                <Typography variant="body2" color="text.secondary">
                  {fileName}
                </Typography>
              </Box>
            )}
          </Grid>
        )}
    </Grid>
  );
  return (
    <GenericPopup
      icon={<EditIcon color="white" fontSize="large" />}
      open={showPopup}
      title={`Edit ${sectionName}`}
      content={newform}
      buttons={[
        {
          text: "Cancel",
          onClick: onCancel,
          color: "secondary",
          variant: "outlined",
        },
        {
          text: "Edit",
          onClick: submit,
          color: "primary",
          variant: "contained",
          loading: loading,
          disabled: isButtonDisable || loading,
          sx: {
            "&.Mui-disabled": {
              backgroundColor: "#e0e0e0",
              color: "#9e9e9e",
            },
          },
        },
      ]}
    />
  );
};
